import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/shadcn/accordion";
import { ReactNode } from "react";

export type FaqItem = { question: string; answer: ReactNode };

/**
 * Shared shell for the /yardim accordion sections — the five of them rendered
 * the same markup around their own hardcoded copy before the strings moved into
 * the `helpContent` catalog.
 */
export default function FaqAccordion({
    items,
    className = "container mb-8 mt-6 flex w-full items-center justify-center gap-6 rounded-md py-3 lg:mt-8",
}: {
    items: FaqItem[];
    className?: string;
}) {
    return (
        <div className={className}>
            <Accordion
                type="single"
                collapsible
                className="w-full rounded-md border border-gray-400 bg-white px-8"
            >
                {items.map((item, index) => (
                    <AccordionItem
                        key={item.question}
                        value={`item-${index + 1}`}
                    >
                        <AccordionTrigger className="my-6 text-[20px]">
                            {item.question}
                        </AccordionTrigger>
                        <AccordionContent className="text-left text-[16px]">
                            {item.answer}
                        </AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </div>
    );
}
